<template>
  <div>
      <DetailAccounts :show_message="show_account_detail" :vat="dialog_vat" @close-message="show_account_detail=false" :key="currentDocument.id.toString()+isWaitingFlow.toString()+'_dialog'"></DetailAccounts>
      <v-row v-if="currentDocument" class="pa-4">
          <v-col cols="12" :sm="6"
                 v-if="currentDocument && (got_feature('feature_document_number_prefix') || showDocNumberStr())">
            <doc-text-field
                kind="text"
                @change="setDirty()"
                v-model="document_doc_number_prefix"
                :label="got_feature('feature_document_number_prefix') ? 'Prefijo núm. documento' : 'Número documento'"
                :disabled="!canChange()"
            />
          </v-col>
          <v-col cols="12" :sm="6"
                 v-if="currentDocument && showDocNumberStr()">
          </v-col>
          <v-col cols="12" :sm="6"
                 v-if="currentDocument && (got_feature('feature_document_number_prefix') || (['accounting_invoice', 'accounting', 'pending_sync', 'done'].includes(currentDocument.state) && got_feature('feature_fill_num_doc_pending_sync')))">
            <doc-text-field
                kind="number"
                @change="setDirty()"
                v-model="document_doc_number"
                label="Núm. documento"
                :disabled="!canChange()"
            />
          </v-col>
          <v-col cols="12" :style="{margin:'0', padding:'0'}"
            v-if="currentDocument.metadata && (Object.keys(currentDocument.metadata).includes('num_pedido') || Object.keys(currentDocument.metadata).includes('agreement_num'))">
            <!-- Número de pedido -->
            <v-col cols="12" :sm="6" v-if="currentDocument.metadata && Object.keys(currentDocument.metadata).includes('num_pedido')">
              <doc-text-field
                @change="setDirty()"
                v-model="currentDocument.metadata['num_pedido']"
                label="Número de pedido"
                :error="currentDocument.errorJson && currentDocument.errorJson.length && currentDocument.errorJson.includes('num_pedido')"
                :disabled="!canChange()"             
              />
            </v-col>
            <!-- Número de acuerdo -->
            <v-col cols="12" :sm="6" v-if="currentDocument.metadata && Object.keys(currentDocument.metadata).includes('agreement_num')">
              <doc-text-field
                @change="setDirty()"
                v-model="currentDocument.metadata['agreement_num']"
                label="Número de acuerdo"
                :error="currentDocument.errorJson && currentDocument.errorJson.length && currentDocument.errorJson.includes('agreement_num')"
                :disabled="!canChange()"             
              />
            </v-col>
          </v-col>
          <v-col cols="12" :sm="6">
            <metadata-field field-key="inv_number" field-text="Núm. factura" :required="true" :key="currentDocument.id.toString()+isWaitingFlow.toString()+'inv_number'" />
          </v-col>
          <template v-if="document_kind=='in_invoice'">
              <v-col v-if="document_supplierdb_info" cols="12" :sm="6">
                  <v-tooltip v-if="currentDocument.errorJson && currentDocument.errorJson.length && currentDocument.errorJson.includes('third_cif')" top>
                      <template v-slot:activator="{ on, attrs }">
                        <doc-text-field  
                          field-text="CIF" 
                          readonly 
                          :value="document_supplierdb_info.cif" 
                          :error="true"
                          v-bind="attrs"
                          v-on="on"
                        />
                      </template>
                      <span>El CIF del tercero debe coincidir con el de la factura</span>
                    </v-tooltip>
                    
                    <!-- If no error, render the field without tooltip -->
                    <doc-text-field  
                      v-else
                      field-text="CIF" 
                      readonly 
                      :value="document_supplierdb_info.cif" 
                      :error="false" 
                    />
              </v-col>
              <v-col cols="12" :sm="6" v-else><metadata-field field-key="vat_supplier" field-text="CIF" :key="currentDocument.id.toString()+isWaitingFlow.toString()+'vat_supplier'" /></v-col>
          </template>
          <template v-else>
              <v-col v-if="document_customerdb_info" cols="12" :sm="6">
                  <v-tooltip v-if="currentDocument.errorJson && currentDocument.errorJson.length && currentDocument.errorJson.includes('third_cif')" top>
                      <template v-slot:activator="{ on, attrs }">
                          
                          <doc-text-field  
                          field-text="CIF" 
                          readonly 
                          :value="document_customerdb_info.cif" 
                          :error="true"
                          v-bind="attrs"
                          v-on="on"
                          />
                          

                      </template>
                      <span>El CIF del tercero debe coincidir con el de la factura</span>
                  </v-tooltip>
                      
                  <!-- If no error, render the field without tooltip -->
                  <doc-text-field  
                  v-else
                  field-text="CIF" 
                  readonly 
                  :value="document_customerdb_info.cif" 
                  :error="false" 
                  />
              </v-col>
              <v-col cols="12" :sm="6" v-else><metadata-field field-key="vat_customer" field-text="CIF" :key="currentDocument.id.toString()+isWaitingFlow.toString()+'vat_customer'"/></v-col>
          </template>
          <v-col cols="12">
              
              <v-row no-gutters v-if="permission.can_write && document_kind=='in_invoice'" >
                  <div v-if="document_kind=='in_invoice' && ['error_multiple_matching_thirds'].includes(currentDocument.state) && !declined_matching" style="font-size:14px">
                  Hay varios proveedores que encajan, elija el correcto:
              </div>
              <v-col cols="9"> 
                  <v-tooltip top :disabled="document_supplierdb_info && valid_expens_accounts && valid_expens_account_bien_inversion">
                      <template v-slot:activator="{ on, attrs }">
                          <div v-if="currentDocument && currentDocument.companydb"> 
                              <autocomplete-with-api
                                  v-if="['error_multiple_matching_thirds'].includes(currentDocument.state) && !declined_matching"
                                  autocomplete="off"
                                  label="Proveedor"
                                  v-model="document_supplierdb_info"
                                  :url="'get_matching_thirds/?doc_id=' + currentDocument.id"
                                  item-text="extended_name"
                                  item_search_field="selector_text"
                                  :disabled="currentDocument.forced_move || !canChange()"
                                  :bck_color="!document_supplierdb_info || (document_supplierdb_info && document_supplierdb_info.credit_account == '') ?'#ff9898':'#ffffff'"
                                  :return_object="true"
                                  :vbind="attrs"
                                  :von="on"
                              >
                              </autocomplete-with-api>
                              <v-autocomplete
                                  v-else-if="['done','done_manually', 'done_with_warning'].includes(currentDocument.state) && !(fixMotxo)"
                                  autocomplete="off"
                                  label="Proveedor"
                                  v-model="document_supplierdb_info"
                                  :items="[document_supplierdb_info]"
                                  item-text="extended_name"
                                  @change="on_supplierdb_changed()"
                                  :disabled="currentDocument.forced_move || !canChange()"
                                  :background-color="!document_supplierdb_info || (document_supplierdb_info && document_supplierdb_info.credit_account == '')?'#ff9898':'#ffffff'"
                                  return-object
                                  :filter="filterBy"
                                  v-bind="attrs"
                                  v-on="on"
                              >
                                  <template slot="item" slot-scope="data">
                                      {{ data.item.cif }} - {{ data.item.name }}
                                  </template>
                              </v-autocomplete>
                              <autocomplete-with-api
                                  v-else-if="feature_search_thirds_by_api"
                                  label="Proveedor"
                                  v-model="document_supplierdb_info"
                                  :starting_items="suppliers"
                                  :url="'get_all_suppliers/?companydb_id=' + currentCompany.id"
                                  item_text="extended_name"
                                  item_search_field="selector_text"
                                  :return_object="true"
                                  :disabled="currentDocument.forced_move || !canChange()"
                                  :bck_color="!document_supplierdb_info || !valid_expens_accounts || !valid_expens_account_bien_inversion || (document_supplierdb_info && document_supplierdb_info.credit_account == '')?'#ff9898':'#ffffff'"
                                  :vbind="attrs"
                                  :von="on"
                                  
                              ></autocomplete-with-api>
                              <v-autocomplete
                                  v-else
                                  autocomplete="off"
                                  label="Proveedor"
                                  v-model="document_supplierdb_info"
                                  :items="suppliers"
                                  item-text="extended_name"
                                  @change="on_supplierdb_changed()"
                                  :disabled="currentDocument.forced_move || !canChange()"
                                  :background-color="!document_supplierdb_info || !valid_expens_accounts || !valid_expens_account_bien_inversion || (document_supplierdb_info && document_supplierdb_info.credit_account == '')?'#ff9898':'#ffffff'"
                                  return-object
                                  :filter="filterBy"
                                  v-bind="attrs"
                                  v-on="on"
                              >
                                  <template slot="item" slot-scope="data">
                                      {{data.item.selector_text}}
                                  </template>
                              </v-autocomplete>
                          </div>
                      </template>
                      <span v-if="!document_supplierdb_info || !valid_expens_accounts || !valid_expens_account_bien_inversion">
                          <div v-if="!document_supplierdb_info">Proveedor no asignado</div>
                          <div v-else-if="!valid_expens_accounts">Cuenta de gastos no asignada</div>
                          <div v-else-if="!valid_expens_account_bien_inversion">Cuenta de gastos en bienes de inversión no asignada</div>
                      </span>
                  </v-tooltip>
              </v-col>
              <v-col cols="3" class="align-self-center" v-if="Boolean(permission.can_write) && (!got_feature('feature_not_create_thirds_and_masters') || (got_feature('feature_not_create_thirds_and_masters') && document_supplierdb_info))">
                  <v-row>
                      <v-col cols="6">
                          <v-btn
                              color="primary"
                              @click="show_modal()"
                              max-width="50"
                              min-width="50"
                              class="ml-1 mb-2"
                          >
                              <v-icon v-if="document_supplierdb_info">mdi-pencil</v-icon>
                              <v-icon v-else>mdi-plus</v-icon>
                          </v-btn>
                      </v-col>
                      <v-col cols="6">
                          <v-btn
                              color="primary"
                              v-if="document_supplierdb_info"
                              outlined
                              max-width="50"
                              min-width="50"
                              @click="document_supplierdb=undefined;document_supplierdb_info=undefined"
                              class=" mb-2"
                              :disabled="currentDocument.forced_move || !canChange()"
                          >
                              <v-icon color="primary">mdi-eraser</v-icon>
                          </v-btn>
                      </v-col>
                  </v-row>
                  
              </v-col>
              </v-row>

              <v-row no-gutters v-else-if="permission.can_write && document_kind=='out_invoice'">
                  <div v-if="document_kind=='out_invoice' && ['error_multiple_matching_thirds'].includes(currentDocument.state) && !declined_matching" style="font-size:14px">
                  Hay varios clientes que encajan, elija el correcto:
                  </div>
              <v-col cols="9">
                  <v-tooltip top :disabled="document_customerdb_info && valid_income_accounts">
                      <template v-slot:activator="{ on, attrs }">
                          <div v-if="currentDocument && currentDocument.companydb">
                              <autocomplete-with-api
                                  v-if="['error_multiple_matching_thirds'].includes(currentDocument.state) && !declined_matching"
                                  autocomplete="off"
                                  label="Cliente"
                                  v-model="document_customerdb_info"
                                  :url="'get_matching_thirds/?doc_id=' + currentDocument.id"
                                  item-text="extended_name"
                                  item_search_field="selector_text"
                                  :disabled="currentDocument.forced_move || !canChange()"
                                  :bck_color="!document_customerdb_info || (document_customerdb_info && document_customerdb_info.debit_account == '')?'#ff9898':'#ffffff'"
                                  :return_object="true"
                                  :vbind="attrs"
                                  :von="on"
                              >
                              </autocomplete-with-api>
                              <v-autocomplete
                                  v-else-if="['done','done_manually', 'done_with_warning'].includes(currentDocument.state) && !(fixMotxo)"
                                  label="Cliente"
                                  autocomplete="off"
                                  v-model="document_customerdb_info"
                                  :items="[document_customerdb_info]"
                                  item-text="extended_name"
                                  item-value="id"
                                  @change="on_customerdb_changed()"
                                  :background-color="!document_customerdb_info || (document_customerdb_info && document_customerdb_info.debit_account == '')?'#ff9898':'#ffffff'"
                                  return-object
                                  :disabled="currentDocument.forced_move || !canChange()"
                                  :filter="filterBy"
                                  v-bind="attrs"
                                  v-on="on"
                              >
                                  <template slot="item" slot-scope="data">
                                      {{ data.item.cif }} - {{ data.item.name }}
                                  </template>
                              </v-autocomplete>
                              <autocomplete-with-api
                                  v-else-if="feature_search_thirds_by_api"
                                  label="Cliente"
                                  v-model="document_customerdb_info"
                                  :starting_items="customers"
                                  :url="'get_all_customers/?companydb_id=' + currentCompany.id"
                                  item_text="extended_name"
                                  item_search_field="selector_text"
                                  :return_object="true"
                                  :disabled="currentDocument.forced_move || !canChange()"
                                  :bck_color="!document_customerdb_info || !valid_income_accounts || (document_customerdb_info && document_customerdb_info.debit_account == '')?'#ff9898':'#ffffff'"
                              ></autocomplete-with-api>
                              <v-autocomplete
                                  v-else
                                  label="Cliente"
                                  autocomplete="off"
                                  v-model="document_customerdb_info"
                                  :items="customers"
                                  item-text="extended_name"
                                  item-value="id"
                                  @change="on_customerdb_changed()"
                                  :background-color="!document_customerdb_info || !valid_income_accounts || (document_customerdb_info && document_customerdb_info.debit_account == '')?'#ff9898':'#ffffff'"
                                  return-object
                                  :disabled="currentDocument.forced_move || !canChange()"
                                  :filter="filterBy"
                                  v-bind="attrs"
                                  v-on="on"
                              >
                                  <template slot="item" slot-scope="data">
                                      {{data.item.selector_text}}
                                  </template>
                              </v-autocomplete>
                          </div>
                      </template>
                      <span v-if="!document_customerdb_info">Cliente no asignado</span>
                          <span v-else-if="!valid_income_accounts">Cuenta de ingresos no asignada</span>
                      </v-tooltip>
              </v-col>
              <v-col cols="3" class="align-self-center" v-if="(!got_feature('feature_not_create_thirds_and_masters') || (got_feature('feature_not_create_thirds_and_masters') && document_customerdb_info))">
                  <v-row>
                      <v-col cols="6">
                          <v-btn
                          color="primary"
                          @click="show_modal()"
                          max-width="50"
                          min-width="50"
                          class="ml-1 mb-2"
                      >
                              <v-icon v-if="document_customerdb_info">mdi-pencil</v-icon>
                              <v-icon v-else>mdi-plus</v-icon>
                          </v-btn>
                  </v-col>
                      <v-col cols="6">
                          <v-btn
                              color="primary"
                              v-if="document_customerdb_info"
                              outlined
                              max-width="50"
                              min-width="50"
                              @click="document_customerdb=undefined;document_customerdb_info=undefined"
                              class=" mb-2"
                              :disabled="currentDocument.forced_move || !canChange()"
                          >
                              <v-icon color="primary">mdi-eraser</v-icon>
                          </v-btn>
                      </v-col>
                  </v-row>

                </v-col>
                </v-row>
                <vies-validator
                    :key="document_kind == 'in_invoice' ? document_supplierdb_info.cif : document_customerdb_info.cif"
                    v-if="got_feature('feature_vies_validation') && currentDocument.intracomunitario && (document_supplierdb_info || document_supplierdb_info)"
                    :third="document_kind == 'in_invoice' ? document_supplierdb_info : document_customerdb_info"
                />
                <v-row v-if="['error_multiple_matching_thirds'].includes(currentDocument.state) && !declined_matching">
                    <v-col cols="6">
                        <v-btn 
                               class="text-none text-subtitle-1" 
                               color="primary" 
                               max-height="25px" 
                               @click="declined_matching=true">
                            Elegir otro tercero
                        </v-btn>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="6" v-if="show_third_concept">
                <metadata-field 
                    style="margin-top:-3vh" 
                    field-key="third_concept" 
                    :required="true" 
                    :readonly="readOnlyThirdConcept"
                    :tabs="tabs" 
                    kind="special_acc" 
                    field-text="Concepto" 
                    :key="currentDocument.id.toString()+isWaitingFlow.toString()+'third_concept'"
                />
            </v-col>
            <v-col cols="6" v-if="show_third_concept"></v-col>
            <!-- Fecha Factura -->
            <v-col cols="6">
                <v-tooltip top :disabled="!errorInvoiceDate">
                    <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on">
                            <metadata-field 
                                field-key="invoice_date" 
                                :editable-forced-move="true" 
                                field-text="Fecha factura" 
                                kind="date" 
                                :initial_error="['error_validating_data','error_checking_taxes'].includes(currentDocument.state) && currentDocument.errorJson.includes('invoice_date')" 
                                :metadata_error="errorInvoiceDate" 
                                :required="true" 
                                :key="currentDocument.id.toString()+isWaitingFlow.toString()+documentFetched.toString()+'invoice_date'"
                                @input="dateErrors_and_setDirty()"
                            />
                        </div> 
                    </template>
                    <span> {{ invoiceTooltip }} </span>
                </v-tooltip>
            </v-col>
            <!-- ########## -->
            <v-col cols="6"><metadata-field field-key="due_date" field-text="Fecha vencimiento" kind="date" :initial_error="['error_validating_data','error_checking_taxes'].includes(currentDocument.state) && currentDocument.errorJson.includes('due_date')" :key="currentDocument.id.toString()+isWaitingFlow.toString()+'due_date'"/></v-col>
            
            <v-col :cols="show_retention_type_name?'3':'6'">
                <metadata-field 
                    field-key="retention_type" 
                    :required="Boolean(currentDocument.metadata['retention_amount'])" 
                    :tabs="tabs" 
                    kind="number" 
                    field-text="% Ret." 
                    :key="currentDocument.id.toString()+isWaitingFlow.toString()+'retention_type'"
                />
            </v-col>
            <v-col :cols="show_retention_type_name?'3':'6'">
                <metadata-field 
                    field-key="retention_amount" 
                    :required="Boolean(currentDocument.metadata['retention_type'])" 
                    :tabs="tabs" 
                    kind="number" 
                    field-text="Retención" 
                    :key="currentDocument.id.toString()+isWaitingFlow.toString()+'retention_amount'"
                />
            </v-col>
            <v-col v-if="show_retention_type_name" cols="6">
                <v-autocomplete
                    :required="Boolean(currentDocument.metadata['retention_amount'])"
                    autocomplete="off"
                    label="Tipo de retención"
                    v-model="document_retention_type_name"
                    :items="filtered_retention_types"
                    class="autocomplete-input pa-0"
                    :hide-details="true"
                    :error="errorRetentionType"
                ></v-autocomplete>
            </v-col>
        </v-row>
        <v-row>
            <!-- Autocomplete Field -->
            <v-col v-if="got_feature('feature_assign_fiscal_location')" cols="12" sm="6" md="15">
              <v-autocomplete
                v-model="currentDocument.fiscal_location"
                autocomplete="off"
                label="Localización Fiscal"
                :items="fiscal_locations"
                :readonly="false"
                class="autocomplete-input pa-0 ml-4"
                @change="on_fiscal_location_changed"
                :class="{'error-background': fiscal_location_error !== ''}"
              ></v-autocomplete>
            </v-col>
            <!-- Error Icon with Tooltip -->
            <v-col v-if="got_feature('feature_assign_fiscal_location') && this.fiscal_location_error !== ''" cols="auto">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon 
                      v-bind="attrs" 
                      v-on="on" 
                      class="error--text" 
                      style="font-size: 20px;"
                    > mdi-alert-circle
                    </v-icon>
                  </template>
                  <span>{{ this.fiscal_location_error }}</span>
                </v-tooltip>
              </v-col>
        </v-row>
        <v-tabs v-model="currentTab">
            <v-tab 
                v-for="tab in visibleTabs" 
                :key="tab.code"
            >
                <div v-if="tab.code == 'params'" >
                    {{tab.text}} <v-icon v-if="someParamsError" color="red">mdi-alert</v-icon>
                </div>
                <div v-else>
                    {{tab.text}}
                </div>
            </v-tab>
        </v-tabs> 
        <v-tabs-items v-model="currentTab" v-if="currentDocument" class="ma-3 table-iva">
            <v-tab-item
                :key="tab.code+'1'"
                v-for="tab in visibleTabs"
            >
                <div v-if="tab.code == 'params'" >
                <v-row no-gutters>
                    <v-col cols="12">
                        <v-row v-if="got_feature('feature_serie_in_docs')">
                            <v-col cols="8">
                                <doc-text-field 
                                    kind="text" 
                                    @change="setDirty()"
                                    v-model="document_serie" 
                                    label="Serie"
                                />
                            </v-col>
                        </v-row>
                        <v-row v-if="showTypes0Error">
                            <v-col cols="8">
                                <div style="color:red">
                                    Las facturas intracomunitarias o con inversion del sujeto pasivo no admiten los impuestos de esta factura.
                                </div>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="8">
                                <v-radio-group v-model="selectedParam" @change="resetParamOption" :key="selectedParam">
                                    <div @click="toggleParam">
                                        <v-radio
                                        :disabled="currentDocument.forced_move || !canChange()"
                                        value="inversion_sujeto_pasivo_iva" label="Inversión sujeto pasivo IVA" />
                                    </div>
                                    <div @click="toggleParam">
                                        <v-radio
                                        :disabled="currentDocument.forced_move || !canChange()"
                                        value="inversion_sujeto_pasivo_igic" label="Inversión sujeto pasivo IGIC" />
                                    </div>
                                    <div @click="toggleParam">
                                        <v-radio
                                        :disabled="currentDocument.forced_move || !canChange()"
                                        value="intracomunitario" label="Intracomunitario" />
                                    </div>
                                    <div @click="toggleParam"  v-if="currentDocument.kind=='out_invoice' || selectedParam == 'extracomunitario' || got_feature('feature_extra_supplier')">
                                        <v-radio
                                        :disabled="currentDocument.forced_move || !canChange()"
                                        value="extracomunitario" label="Extracomunitario" />
                                    </div>
                                    <div @click="toggleParam" v-if="feature_supplier_comerciante_minorista && currentDocument.kind=='in_invoice'"> <!-- Este feature es un computed que usa got_feature -->
                                        <v-radio
                                            :disabled="currentDocument.forced_move || !canChange()"
                                            value="is_comerciante_minorista" 
                                            label="Comerciante Minorista" 
                                        />
                                    </div>
                                    <div @click="toggleParam" v-if="feature_no_sujeta">
                                        <v-radio
                                        :disabled="currentDocument.forced_move || !canChange()"
                                        value="no_sujeta" label="No sujeta" />
                                    </div>
                                </v-radio-group>
                            </v-col>
                            <v-col cols="4" v-if="selectedParam && PROVIDER_SOMETHING_OPTIONS[selectedParam]">
                                <v-autocomplete
                                    v-model="selectedParamOption"
                                    v-if="currentDocument.kind=='in_invoice'"
                                    :disabled="currentDocument.forced_move || !canChange()"
                                    autocomplete="off"
                                    :label="selectedParam === 'extracomunitario' ? 'Importaciones' : 'Porcentaje'"
                                    :items="PROVIDER_SOMETHING_OPTIONS[selectedParam]"
                                    :background-color="taxTypesDoNotMatch ? '#ff9898' : '#ffffff'"
                                    :readonly="currentDocument.forced_move || !canChange()"
                                />
                                <v-autocomplete
                                    v-if="(selectedParam == 'intracomunitario' && feature_intra_type) || (selectedParam == 'extracomunitario' && (feature_extra_type || feature_extracomunitario_type))"
                                    v-model="selectedParamOption2"
                                    :disabled="currentDocument.forced_move || !canChange()"
                                    autocomplete="off"
                                    label="Tipo"
                                    :items="PROVIDER_SOMETHING_OPTIONS2[selectedParam]"
                                    :readonly="currentDocument.forced_move || !canChange()"
                                />
                            </v-col>
                        </v-row>
                        <v-divider role="separator" aria-orientation="horizontal" class="v-divider theme--light"/>
                        <v-row v-if="feature_bien_inversion">
                            <v-col cols="8" class="ml-3 pa-0 ma-0">
                                <v-checkbox @change="checkBienInversion()"
                                :disabled="currentDocument.forced_move || !canChange()"
                                v-model="document_bien_inversion" label="Bienes de inversión" />
                            </v-col>
                        </v-row>
                        <v-row v-if="got_feature('feature_rebu')">
                            <v-col cols="4" class="ml-3 pa-0 ma-0 pt-1">
                                <v-checkbox
                                @change="checkRebu()"
                                :disabled="currentDocument.forced_move || !canChange()"
                                v-model="document_rebu" label="REBU" />
                            </v-col>
                            <v-col cols="6" v-if="document_rebu && currentDocument.kind === 'out_invoice'" class="pa-0 ma-0 pt-1">
                                <doc-text-field
                                    kind="number"
                                    label="Precio Compra"
                                    v-model="document_rebu_precio_compra"
                                    :readonly="currentDocument.forced_move || !canChange()"
                                    @change="setDirty()"
                                    :required="true"
                                    :error="document_rebu && currentDocument.kind === 'out_invoice' && !document_rebu_precio_compra"
                                ></doc-text-field>
                            </v-col>
                        </v-row>
                        <v-divider role="separator" aria-orientation="horizontal" class="v-divider theme--light" v-if="got_feature('feature_rebu')"/>
                        <v-row v-if="currentDocument.kind=='in_invoice'">
                            <v-col cols="8">
                                <v-tooltip top :disabled="!noDeducibleCheckError && !isComercianteMinoristaCheckError">
                                    <template v-slot:activator="{ on, attrs }">
                                        <div v-bind="attrs" v-on="on">
                                            <v-radio-group v-model="selectedIvaCheck" :error="noDeducibleCheckError || isComercianteMinoristaCheckError">
                                                <div @click="toggleParamIva">
                                                    <v-radio
                                                    :disabled="currentDocument.forced_move || !canChange()"
                                                    value="iva_igic_no_deducible" label="IVA/IGIC no deducible" />
                                                </div>
                                                <div @click="toggleParamIva" v-if="feature_gasto_iva_parcial">
                                                    <v-radio
                                                    :disabled="currentDocument.forced_move || !canChange()"
                                                    value="gasto_iva_parcial" label="Gasto+IVA deducible parcialmente" />
                                                </div>
                                                <div @click="toggleParamIva" v-if="feature_iva_deducible_parcialmente">
                                                    <v-radio
                                                    :disabled="currentDocument.forced_move || !canChange()"
                                                    value="iva_parcial" label="IVA deducible parcialmente" />
                                                </div>
                                                <div @click="toggleParamIva" v-if="feature_prorate && currentDocument.kind == 'in_invoice' && currentDocument.companydb_info.prorate && currentPath()['prorate_percent'] != 'N/A'">
                                                    <v-radio
                                                    :disabled="currentDocument.forced_move || !canChange()"
                                                    value="prorate" label="Prorrata" />
                                                </div>
                                            </v-radio-group>
                                        </div>
                                    </template>
                                    <span v-if="noDeducibleCheckError">Funcionalidad no soportada: Factura con IVA/IGIC no deducible e {{(selectedParam=='intracomunitario' && 'Intracomunitario') || (selectedParam=='inversion_sujeto_pasivo_iva' && 'Inversión sujeto pasivo IVA') || (selectedParam=='inversion_sujeto_pasivo_igic' && 'Inversión sujeto pasivo IGIC')}}.</span>
                                    <span v-if="isComercianteMinoristaCheckError">Funcionalidad no soportada: Factura con Comerciante Minorista y Deducibilidad.</span>
                                </v-tooltip>
                            </v-col>
                            <v-col cols="4">
                                <v-checkbox
                                    v-if="selectedIvaCheck=='iva_igic_no_deducible' && feature_comerciante_minorista && currentDocument.companydb_info.companydb_type.params && ((!currentDocument.companydb_info.companydb_type.params.hasOwnProperty('hide')) || (currentDocument.companydb_info.companydb_type.params.hide && !currentDocument.companydb_info.companydb_type.params.hide.includes('comerciante_minorista')))"
                                    :disabled="currentDocument.forced_move || !canChange()"
                                    label="Registrar en libro de facturas"
                                    v-model="document_comerciante_minorista"
                                ></v-checkbox>
                                <doc-text-field
                                    v-if="selectedIvaCheck=='gasto_iva_parcial' || selectedIvaCheck=='iva_parcial'"
                                    kind="number"
                                    label="Porcentaje"
                                    v-model="document_gasto_iva_percent"
                                    :disabled="currentDocument.forced_move || !canChange()"
                                    :required="true"
                                    :error="document_gasto_iva_percent<=0 || document_gasto_iva_percent>=100 || (document_errorJson.length > 0 && document_errorJson.includes('gasto_iva_percent'))"
                                ></doc-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row v-if="feature_building_code && currentCompany && currentCompany.companydb_type.params && currentCompany.companydb_type.params['show'] && currentCompany.companydb_type.params['show'].includes('building_code')" no-gutters>
                    <v-col cols='12'>
                       <doc-text-field 
                            kind="text" 
                            @change="setDirty()"
                            :disabled="!canChange()"
                            v-model="document_building_code" label="Código de inmueble" />
                    </v-col>
                </v-row>
                <v-row v-if="!(Boolean(currentDocument.metadata['retention_amount']) || Boolean(currentDocument.metadata['retention_type'])) && selectedParam != 'extracomunitario' && feature_apply_347 && currentCompany && currentCompany.companydb_type.params && currentCompany.companydb_type.params['show'] && currentCompany.companydb_type.params['show'].includes('apply_347')" no-gutters>
                    <v-col cols='12'>
                        <v-checkbox 
                            kind="text" 
                            @change="setDirty()"
                            :disabled="!canChange()"
                            v-model="document_apply_modelo" 
                            :label="apply_modelo_label" 
                        />
                    </v-col>
                </v-row>
                <v-row v-if="got_feature('feature_apply_415') && currentCompany.apply_415">
                    <v-col cols='12'>
                        <v-checkbox 
                            kind="text" 
                            @change="setDirty()"
                            :disabled="!canChange()"
                            v-model="document_apply_415" 
                            label="Aplica 415" 
                        />
                    </v-col>
                </v-row>
                <v-row v-if="feature_criterio_de_caja">
                    <v-col>
                        <v-checkbox 
                            @change="setDirty()"
                            :disabled="!canChange()"
                            v-model="document_criterio_de_caja" 
                            label="Criterio de Caja" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">                                                               
                        <v-checkbox v-if="!(rectification_invoice===undefined)" 
                            :disabled="!canChange()"
                            v-model="rectification_invoice"
                            @change="toggleIsRectificativa" 
                            label="Factura rectificativa"/>

                  </v-col>
              </v-row>
              <v-row v-if="showRectifyFields()">
                  <v-col :cols="got_feature('feature_invoice_date_to_rectify')?'6':'12'">
                      <autocomplete-with-api
                          label="Nº factura rectificada"
                          :can_add_new="true"
                          v-model="invoice_to_rectify"
                          :starting_items="[]"
                          :url="url_get_invoices_to_rectify"
                          item_text="inv_number"
                          search_field_name="metadata__inv_number__icontains"
                          item_search_field="inv_number"
                          :return_object="true"
                          :disabled="!canChange()"                        
                          classes="ma-0 pa-0"
                          @input="changeInvNumberToRectify"
                          :bck_color="inv_number_to_rectify_error?'#ff9898':'#ffffff'"
                      ></autocomplete-with-api>
                  </v-col>
                  <v-col cols="6" v-if="got_feature('feature_invoice_date_to_rectify')">
                      <doc-text-field 
                          kind="date" 
                          label="Fecha factura rectificada"
                          v-model="document_inv_date_to_rectify"
                          :error="inv_date_to_rectify_error"
                          :disabled="!canChange()"
                      ></doc-text-field >
                  </v-col>
              </v-row>
              <v-row v-if="currentDocument.companydb_info && currentDocument.companydb_info.companydb_type.type == 'invoice' && (currentDocument.companydb_info.companydb_type.params && ((!currentDocument.companydb_info.companydb_type.params.hasOwnProperty('hide')) || (currentDocument.companydb_info.companydb_type.params.hide && !currentDocument.companydb_info.companydb_type.params.hide.includes('prefix_invoice'))))" no-gutters>
                  <v-col cols='12'>
                      <v-checkbox @change="setDirty()"
                          :disabled="!canChange()"
                          v-model="document_written_description" label="Personalizar descripción" />
                  </v-col>
              </v-row>
              <v-row v-if="currentDocument.companydb_info && currentDocument.companydb_info.companydb_type.type == 'invoice' && (currentDocument.companydb_info.companydb_type.params && ((!currentDocument.companydb_info.companydb_type.params.hasOwnProperty('hide')) || (currentDocument.companydb_info.companydb_type.params.hide && !currentDocument.companydb_info.companydb_type.params.hide.includes('prefix_invoice'))))" no-gutters>
                  <v-col cols='12'>
                      <doc-text-field 
                          kind="text" 
                          @change="setDirty()"
                          :disabled="!document_written_description || !canChange()"
                          v-model="document_description" label="Descripción" />
                  </v-col>
              </v-row>

              <v-row v-if="currentCompany && currentCompany.available_features && currentCompany.available_features.feature_description_sii">
                  <v-col cols='12'>
                      <v-checkbox @change="setDirty()"
                          :disabled="!canChange()"
                          v-model="document_written_description_sii" label="Personalizar descripción SII" />
                  </v-col>
              </v-row>
              <v-row v-if="currentCompany && currentCompany.available_features && currentCompany.available_features.feature_description_sii">
                  <v-col cols='12'>
                      <doc-text-field 
                          kind="text" 
                          @change="setDirty()"
                          :disabled="!document_written_description_sii || !canChange()"
                          v-model="document_description_sii" 
                          label="Descripción SII" 
                          :error="showRequiredDescriptionSII"/>
                  </v-col> 
              </v-row>
              <div class="ma-0 pa-0" v-if="got_feature('feature_automatic_moves_in_document')">    
                  <v-row v-if="document_kind == 'in_invoice'">
                      <v-col cols="3">
                          <v-text-field
                          disabled
                          v-model="automaticPaymentAccountLabel"
                          label="Pago auto."
                          />
                      </v-col>
                      <v-col class="d-flex align-center" cols="9">
                          <v-text-field
                          :label="cru_label_payment_account"
                          v-model="document_payment_account"
                          />
                      </v-col>
                  </v-row>
                  <v-row v-else-if="document_kind == 'out_invoice'">
                      <v-col cols="3">
                          <v-text-field
                              disabled
                              v-model="automaticChargeAccountLabel"
                              label="Cobro auto."
                          />
                      </v-col>
                      <v-col cols="9">
                          <v-text-field
                              v-model="document_charge_account"
                              :label="cru_label_charge_account"
                          />
                      </v-col>
                  </v-row>
              </div>
              </div>
              <v-row v-else no-gutters>
                  
                  <template v-if="currentDocument.companydb_info && currentDocument.companydb_info.companydb_type && currentDocument.companydb_info.companydb_type.type == 'invoice' && currentDocument.companydb_info.companydb_type.params && currentDocument.companydb_info.companydb_type.params.desglose_de_cuentas">
                      <v-col cols="2" class="text-center table-head-invoice primary--text">Tipo</v-col>
                      <v-col cols="3" class="text-center table-head-invoice primary--text">Base</v-col>
                      <v-col cols="3" class="text-center table-head-invoice primary--text">Cuota</v-col>
                      <v-col cols="4" class="text-center table-head-invoice primary--text">Cuenta</v-col>
                  </template>
                  <template v-else>
                      <v-col :cols="get_tipo_cols()" class="text-center table-head-invoice primary--text">Tipo</v-col>
                      <v-col cols="4" class="text-center table-head-invoice primary--text">Base</v-col>
                      <v-col :cols="get_cuota_cols()" class="text-center table-head-invoice primary--text">Cuota</v-col>
                      <v-tooltip top v-if="typeCheckRet != 'none'">
                              <template v-slot:activator="{ on, attrs }">
                                  <v-btn  v-bind="attrs" 
                                          v-on="on"
                                          :key="'ampl'" 
                                          small  
                                          color="primary"
                                          icon
                                          @click="conf_ret_button=!conf_ret_button"
                                          :style="{'margin-left':cusRetMarginLeft}"
                                          >
                                      <v-icon >mdi-dots-vertical</v-icon>
                                  </v-btn>
                              </template>
                          <span v-if="!showCustomRet"> Mostrar columna base retención</span>
                          <span v-else-if="!hasSomeCustomRet"> Ocultar columna</span>
                      </v-tooltip>
                      <template v-if="showCustomRet && typeCheckRet != 'none'">
                          <v-col cols="2" v-if="typeCheckRet=='checkbox'" class="text-center table-head-invoice primary--text">Apl. Ret.</v-col>
                          <v-col cols="2" v-else-if="typeCheckRet=='base'" class="text-center table-head-invoice primary--text">Base Ret.</v-col>
                      </template>
                  </template>
                  <template v-for="vat in tab.vats" >
                      <template v-if="currentCompany && show_vat(vat.vat)">
                          <template v-if="Boolean(currentDocument.metadata['detail_'+vat.vat]) && currentDocument.metadata['detail_'+vat.vat].length>0">
                              <v-col :key="'label_'+vat.vat" cols="2" class="text-center table-row-invoice">
                                  <doc-text-field 
                                      kind="text"
                                      readonly 
                                      :value="get_label(vat)" 
                                      :key="currentDocument.id.toString()+isWaitingFlow.toString()+'label_'+vat.vat"
                                  />
                              </v-col>
                              <v-col :key="'base_'+vat.vat" cols="3" class="text-center table-row-invoice">
                                  <metadata-field 
                                      kind="detail_number" 
                                      :field-key="'base_'+vat.vat" 
                                      :field-check="[vat.vat,vat.coef]" 
                                      field-text="" 
                                      :key="currentDocument.id.toString()+isWaitingFlow.toString()+'base_'+vat.vat"
                                      :initial_error="document_errorJson && document_errorJson.constructor === Array && document_errorJson.includes('base_'+vat.vat)"
                                  />  
                              </v-col>
                              <v-col :key="'vat_'+vat.vat" cols="3" class="text-center table-row-invoice">
                                  <metadata-field 
                                      kind="detail_number" 
                                      :field-key="vat.vat" 
                                      :field-check="[vat.vat,vat.coef]" 
                                      field-text="" 
                                      :key="currentDocument.id.toString()+isWaitingFlow.toString()+vat.vat"
                                  />  
                              </v-col>
                              <v-col :key="'account_'+vat.vat" cols="4" class="text-center table-row-invoice">
                                  <v-row no-gutters>
                                      <v-col cols="9">
                                          <metadata-field 
                                              kind="detail_account" 
                                              :field-key="vat.vat" 
                                              field-text="" 
                                              :key="currentDocument.id.toString()+isWaitingFlow.toString()+'account_'+vat.vat"
                                          />
                                      </v-col>
                                      <v-col cols="3">
                                          <v-btn :key="'dialog_'+vat.vat" small @click="dialog_vat=vat; show_account_detail=true"
                                              color="primary"
                                              icon
                                              >
                                              <v-icon>mdi-pencil</v-icon>
                                          </v-btn>
                                      </v-col>
                                  </v-row>
                                  
                                  
                              </v-col>
                          </template>
                          <template v-else-if="currentDocument.companydb_info && currentDocument.companydb_info.companydb_type && currentDocument.companydb_info.companydb_type.type == 'invoice' && currentDocument.companydb_info.companydb_type.params && currentDocument.companydb_info.companydb_type.params.desglose_de_cuentas">
                              <v-col :key="'label_'+vat.vat" cols="2" class="table-row-invoice" >
                                  <doc-text-field 
                                      v-if="vat.vat.includes('_re_')"
                                      kind="text" 
                                      readonly 
                                      :small_font="true"
                                      :value="get_label(vat)" 
                                      :key="currentDocument.id.toString()+isWaitingFlow.toString()+'label_'+vat.vat"
                                  />
                                   <doc-text-field 
                                      v-else
                                      kind="text" 
                                      readonly 
                                      :value="get_label(vat)" 
                                      :key="currentDocument.id.toString()+isWaitingFlow.toString()+'label_'+vat.vat"
                                  />
                              </v-col>
                              <v-col :key="'vat_'+vat.vat" cols="3" class="table-row-invoice">
                                  <metadata-field 
                                      kind="number" 
                                      :required="Boolean(currentDocument.metadata[vat.vat])" 
                                      :field-key="'base_'+vat.vat" 
                                      :field-check="[vat.vat,vat.coef]" 
                                      field-text="" 
                                      :key="currentDocument.id.toString()+isWaitingFlow.toString()+'base_'+vat.vat"
                                      :fill-account="vat.vat"
                                      :initial_error="document_errorJson && document_errorJson.constructor === Array && document_errorJson.includes('base_'+vat.vat)"
                                  />
                              </v-col>
                              <v-col :key="'base_'+vat.vat" cols="3" class="table-row-invoice">
                                  <metadata-field 
                                      kind="number" 
                                      :required="Boolean(currentDocument.metadata['base_'+vat.vat])" 
                                      :field-key="vat.vat" 
                                      :field-check="['base_'+vat.vat,vat.coef]" 
                                      field-text="" 
                                      :key="currentDocument.id.toString()+isWaitingFlow.toString()+vat.vat"
                                      :fill-account="vat.vat"
                                  /></v-col>
                              <v-col :key="'account_'+vat.vat" cols="4" class="text-center table-row-invoice">
                                  <v-row no-gutters>
                                      <v-col cols="9">
                                          <metadata-field 
                                              :kind="got_feature('feature_accounts_master') ? 'account_am' : 'account'"
                                              :required="Boolean(currentDocument.metadata['account_'+vat.vat])" 
                                              :field-key="'account_'+vat.vat" 
                                              field-text="" 
                                              :key="currentDocument.id.toString()+isWaitingFlow.toString()+'account_'+vat.vat"
                                              :num_digits="currentDocument.companydb_info.num_digits"
                                              :items="got_feature('feature_accounts_master') ? accounts : []"
                                              @get-values="getValues"
                                              @reset-items="resetItems"
                                          />
                                      </v-col>
                                      <v-col cols="3">
                                          <v-btn :key="'dialog_'+vat.vat" @click="dialog_vat=vat; show_account_detail=true"
                                              color="primary"
                                              icon
                                              >
                                              <v-icon>mdi-pencil</v-icon>
                                          </v-btn>
                                      </v-col>
                                  </v-row>
                                  
                              </v-col>
                          </template >
                          <template v-else>
                              <v-col :key="'label_'+vat.vat" :cols="get_tipo_cols()" class="table-row-invoice">
                                  <doc-text-field 
                                      kind="text" 
                                      readonly 
                                      :value="get_label(vat)" 
                                      :key="currentDocument.id.toString()+isWaitingFlow.toString()"
                                  />
                              </v-col>
                              <v-col :key="'vat_'+vat.vat" cols="4" class="table-row-invoice">
                                  <metadata-field 
                                      kind="number" 
                                      :required="Boolean(currentDocument.metadata[vat.vat])" 
                                      :field-key="'base_'+vat.vat" 
                                      :field-check="[vat.vat,vat.coef]" 
                                      field-text="" 
                                      :key="currentDocument.id.toString()+isWaitingFlow.toString()"
                                  /></v-col>
                              <v-col :key="'base_'+vat.vat" :cols="get_cuota_cols()" class="table-row-invoice">
                                  <metadata-field 
                                      kind="number" 
                                      :required="Boolean(currentDocument.metadata['base_'+vat.vat])" 
                                      :field-key="vat.vat" 
                                      :field-check="['base_'+vat.vat,vat.coef]" 
                                      field-text="" 
                                      :key="currentDocument.id.toString()+isWaitingFlow.toString()"
                                  /></v-col>
                              <template v-if="showCustomRet">
                                  <v-col v-if="typeCheckRet == 'checkbox'" :key="'check_ret_'+vat.vat" cols="2" class="table-row-invoice">
                                      <metadata-field v-if="!vat.vat.includes('_re_') " :field-key="'not_ret_'+vat.vat" kind="boolean" field-text="" :key="currentDocument.id.toString()+isWaitingFlow.toString()+'checkret'"/>
                                  </v-col>
                                  <v-col v-else-if="typeCheckRet == 'base'" :key="'check_ret_'+vat.vat" cols="2" class="table-row-invoice">
                                      <metadata-field v-if="!vat.vat.includes('_re_') " 
                                                      :field-key="'ret_base_'+vat.vat" 
                                                      :field-check="['base_'+vat.vat,vat.coef]" 
                                                      kind="number" 
                                                      field-text="" 
                                                      :key="currentDocument.id.toString()+isWaitingFlow.toString()+'baseret'"/>
                                  </v-col>
                              </template>
                          </template>
                      </template>
                  </template>
              </v-row>
              
          </v-tab-item>
      </v-tabs-items>
      <v-row v-if="currentDocument" class="pa-4">
          <v-col cols="12" sm="6">
              <metadata-field v-if="currentDocument.companydb_info && (currentDocument.companydb_info.companydb_type.params && ((!currentDocument.companydb_info.companydb_type.params.hasOwnProperty('hide')) || (currentDocument.companydb_info.companydb_type.params.hide && !currentDocument.companydb_info.companydb_type.params.hide.includes('other_amounts'))))"
                  field-key="other_amounts" 
                  kind="number" 
                  field-text="Suplidos" 
                  :key="currentDocument.id.toString()+isWaitingFlow.toString()+'other_amounts'"
                  :initial_error="document_errorJson && document_errorJson.constructor === Array && document_errorJson.includes('other_amounts')"
                  />
              </v-col>
          <v-col cols="12" sm="6"><metadata-field field-key="total_amount" kind="number" :required="true" :tabs="tabs" field-text="Total factura" :key="currentDocument.id.toString()+isWaitingFlow.toString()+'total_amount'"/></v-col>
      </v-row>
      <v-row v-if="currentDocument" class="pa-4">
          <v-col cols="6" >
              <metadata-field v-if="feature_see_albaran"
                  field-key="delivery_note_number" 
                  kind="text" 
                  field-text="Núm. Albarán" 
                  :key="currentDocument.id.toString()+isWaitingFlow.toString()+'delivery_note_number'"/>
          </v-col>
          
      </v-row>
  </div>
</template>

<script>
import _ from 'lodash'
import MetadataField from './MetadataField.vue'
import DocTextField from './DocTextField.vue'
import DetailAccounts from './DetailAccounts.vue'
import AutocompleteWithApi from './AutocompleteWithApi.vue'
import ViesValidator from './ViesValidator.vue'
import DatePicker from './DatePicker.vue'
import {mapFieldsMetadata} from "../store/vuex_utils"
import { STANDARD_LABELS_CLIENT } from "../store/constants";

import { mapActions, mapGetters, mapState } from "vuex";
import { mapFields } from 'vuex-map-fields';
import {vuexPrefix} from "../store/vuex_utils"
import { PROVIDER_SOMETHING_OPTIONS } from '../store/constants.js';
import { PROVIDER_SOMETHING_OPTIONS2 } from '../store/constants.js';
import { dateIsInPaths } from '../utils';
import { showErrorRetentionType } from "../modules/invoices/domain/Invoice"
import { query_dispatcher, sync_command_dispatcher } from "@/api/client";
import { GetFiscalLocationInfoQuery } from "@/modules/invoices/app/GetFiscalLocationInfoQuery";

import { invoiceDateErrors, inAccountingPeriodErrors, diff5Years } from "@/modules/invoices/domain/Invoice"
import { VueFeatureRepository } from "../modules/shared/infra/FeatureRepository"
  export default {
      name:'InvocieInfo',
      components:{
          MetadataField,
          DocTextField,
          DetailAccounts,
          AutocompleteWithApi,
          ViesValidator,
          DatePicker,
      },
      created() {
          this.accounts = [];
          this.rectification_invoice = this.is_rectificativa;            
      },
      computed:{
          ...mapState('tax_tab', ['vat', 'igic']),
          ...mapGetters({
              currentDocument: "documents/currentDocument",
              isWaitingFlow: "documents/isWaitingFlow",
              documentFetched: 'documents/documentFetched',
              automaticPaymentAccount: 'documents/automatic_payment_account',
              automaticChargeAccount: 'documents/automatic_charge_account',
              suppliers: "get_suppliers",
              customers: "get_customers",
              userData: "me/userData",
              currentCompany:"getCurrentCompany",
              fixMotxo:'fixMotxo',
              tabs: "tax_tab/getInitialTab",
              get_retention_types: 'get_retention_types_docs',
              permission: 'permissions/permission',
              got_feature: 'got_feature',
          }), 
          ...mapGetters('documents',['sumBasesIva','sumBasesIgic','sumBases','has_meta_igic','has_meta_igic2019','has_meta_iva','has_meta_igi','sumBasesIgi']),
          ...mapFields('documents',vuexPrefix('document_',[
              'kind','state','bien_inversion','rebu','rebu_precio_compra','supplierdb','customerdb','supplierdb_info','customerdb_info','comerciante_minorista',
              'gasto_iva_percent', 'errorJson','written_description','description', 'prorate','building_code','apply_modelo', 'apply_415', 'serie',
              'doc_number', 'retention_type_name', 'criterio_de_caja', 'written_description_sii', 'description_sii', 'payment_account', 'charge_account',
              'is_comerciante_minorista', 'inv_number_to_rectify', 'inv_date_to_rectify', 'doc_number_prefix', 'doc_number',
          ],'document.')),
          // ...mapFields(['showModalSupplier','showModalCustomer']),
          ...mapFields('me',vuexPrefix('',[
              'feature_comerciante_minorista', 'feature_no_sujeta', 'feature_bien_inversion', 'feature_intra_type', 'feature_extra_type', 'feature_extracomunitario_type', 'feature_gasto_iva_parcial',
              'feature_prorate','feature_building_code','feature_iva_deducible_parcialmente','feature_apply_347','feature_vat_5',
              'feature_search_thirds_by_api', 'feature_base_retention', 'feature_see_albaran', 'feature_customer_retention_type', 
              'feature_retention_accounts_agrario', 'feature_criterio_de_caja', 'feature_expens_account_metadata'
          ],'userData.available_features.')),
          ...mapFieldsMetadata(vuexPrefix('metadata_',STANDARD_LABELS_CLIENT.map(x=>x.name),'')),
          ...mapFields('cru',['accounts', 'label_automatic_payment_account']),
          ...mapFields('cru', vuexPrefix('cru_label_', ['payment_account', 'charge_account'], 'inputLabels.')),
          ...mapActions({
              setSuppliers: "setSuppliersPromise",
          }),
          ...mapFields('documents', ['selectedParam', 'selectedParamOption', 'selectedParamOption2', 'selectedIvaCheck']),
          currentTab:{
              get(){
                  if(this.clickedTab!=undefined){
                      return this.clickedTab
                  }else if(typeof(this.sumBasesIva)=='string' || typeof(this.sumBasesIgi)=='string'){
                      return 0
                  }else if(typeof(this.sumBasesIgic)=='string'){
                      if(this.currentCompany.tax_type.includes('iva'))
                          return 1
                      else
                          return 0
                  }else{
                      if(this.currentCompany && this.currentCompany.tax_type && this.currentCompany.tax_type.includes('iva') && this.currentCompany.tax_type.includes('igic')){
                          return Math.abs(this.sumBasesIva)>=Math.abs(this.sumBasesIgic)?0:1
                      }
                      return 0
                  }   
              },
              set(newValue){
                  if(newValue!=this.currentTab)
                      this.clickedTab=newValue
              },
          },
          // ==========
          // ==========
          errorInvoiceDate() {
            return this.date_errors.invoice || this.error5years === true
          },
          invoiceTooltip() {
            if (this.error5years === true) return this.date_tooltips.acc_inv_5y
            else return ""
          },
          errorAccountingDate() {
            return this.date_errors.accounting || this.inAccounting_errors.accounting
          },
          errorAccountingDateSelect() {
            return this.errorAccountingDate && this.currentDocument.accounting_date_config != 'configurated'
          },
          accountingTooltip() {
            return this.inAccounting_errors.accounting ? this.date_tooltips.no_acc_period : this.date_tooltips.acc_date_before_invoice
          },
          errorRegistroDate() {
            return this.date_errors.registro
          },
          errorRegistroDateSelect() {
            return this.errorRegistroDate && this.currentDocument.registro_date_config != 'configurated'
          },
          registroTooltip() {
            return this.date_tooltips.reg_date_before_invoice
          },
          // ==========
          // ==========
          errorRetentionType(){
              let missing_fields = {};
              if(this.currentDocument.errorJson){
                  missing_fields = this.currentDocument.errorJson['missing_fields'];
              }
              
              let invoice = {
                  state:this.currentDocument.state,
                  missing_fields : missing_fields,
                  retention_type_name:this.document_retention_type_name,
                  retention_percent:this.currentDocument.metadata?this.currentDocument.metadata['retention_type']:false,
                  retention_amount:this.currentDocument.metadata?this.currentDocument.metadata['retention_amount']:false,

              }
              return showErrorRetentionType(invoice)
          },
          typeCheckRet(){
              let type = 'none'
              if (this.currentCompany.check_ret){
                  type = 'checkbox'
              }
              else if((this.feature_base_retention && this.currentCompany && this.currentCompany.companydb_type && this.currentCompany.companydb_type.type == 'account_move')){
                  type = 'base'
              }
              else if(this.feature_base_retention && this.currentCompany && this.currentCompany.companydb_type && this.currentCompany.companydb_type.type == 'invoice'){
                  if(this.currentDocument.companydb_info.companydb_type.params && this.currentDocument.companydb_info.companydb_type.params.desglose_de_cuentas){
                      type = 'detail'
                  }
                  else{
                      type = 'base'
                  }
              }
              return type
          },
          someParamsError(){
              return this.showRequiredDescriptionSII || this.showTypes0Error
          },
          showRequiredDescriptionSII(){
              return this.currentDocument.state == 'error_missing_fields' && this.currentDocument.errorJson['missing_fields'].includes('description_sii') && !this.document_description_sii
          },
          showTypes0Error(){
              return this.currentDocument.state == 'error_checking_taxes' && this.currentDocument.errorJson.includes("type_0_incompatibilities") && this.got_feature('feature_type_0_errors') && this.selectedParam
          },
          hasSomeCustomRet(){
              for(let i in this.tabs){
                      let vats = this.tabs[i].vats
                      for(let j in vats){
                          let vat = vats[j].vat
                          let rb = 'ret_base_'+vat
                          let na = 'not_apl_ret_'+vat
                          let nr = 'not_ret_'+vat
                          if( this.currentDocument.metadata[rb] || this.currentDocument.metadata[rb]==0 || this.currentDocument.metadata[na] || this.currentDocument.metadata[nr]){
                              if(this.currentDocument.metadata[rb] != ''){ //no entenc com considera els no booleans js
                                  return true
                              }
                          }
                      }
              }
              return false
          },
          showCustomRet(){
              return this.hasSomeCustomRet || this.conf_ret_button
          },
          cusRetMarginLeft(){
              return '-7%'
          },
          visibleTabs() {
          
              // Define impost metadata for each impost tab.
              //const metadataTabsMap = {
              //    'iva':      this.has_meta_iva,
              //    'igic':     this.has_meta_igic,
              //    'igic2019': this.has_meta_igic2019,
              //    'igi':      this.has_meta_igi,
              //};
  
              let visibleTabs = null;
  
              // If the Document's fiscal_location is set and matches a location in the locations tab map,
              // prioritize the impost tab corresponding to that fiscal_location.
              // If not, go the old way.
              if (
                  this.got_feature('feature_assign_fiscal_location')
                  && this.currentDocument.fiscal_location
                  && Object.values(fiscalLocationsTabsMap).some(
                      locations => locations.includes(this.currentDocument.fiscal_location)
                  )
              ) {
                  /**
                  * Generate a formatted mapping of fiscal locations.
                  *
                  * An example of the output structure:
                  * {
                  *   'iva':      ['peninsula'],
                  *   'igic':     ['canarias'],
                  *   'igic2019': ['canarias_2019'],
                  *   'igi':      ['andorra']
                  * }
                  */
                  const fiscalLocationsTabsMap = {};
                  this.fiscal_locations.forEach(({ value, impost_types }) => {
                      impost_types.forEach(type => {
                          if (!fiscalLocationsTabsMap[type]) {
                              fiscalLocationsTabsMap[type] = [];
                          }
                          fiscalLocationsTabsMap[type].push(value);
                      });
                  });
  

                  visibleTabs = this.tabs.filter(tab => {
                      if (tab.code === 'params') {
                          return this.document_supplierdb_info || this.document_customerdb_info;
                      }
                      if (fiscalLocationsTabsMap[tab.code]) {
                          //return fiscalLocationsTabsMap[tab.code].includes(this.currentDocument.fiscal_location) || metadataTabsMap[tab.code];
                          return fiscalLocationsTabsMap[tab.code].includes(this.currentDocument.fiscal_location);
                      }
                      return [];
                  });
              } else {
                  visibleTabs = this.tabs.filter(tab => {
                      if (tab.code == 'params') {
                          return this.document_supplierdb_info || this.document_customerdb_info;
                      } else if (tab.code == 'iva' && this.currentCompany && this.currentCompany.tax_type) {
                          return this.currentCompany.tax_type.includes(tab.code) || this.has_meta_iva;
                      } else if (tab.code == 'igic2019'  && this.currentCompany && this.currentCompany.tax_type) {
                          return this.currentCompany.tax_type==tab.code || this.has_meta_igic2019;
                      } else if (tab.code == 'igic'  && this.currentCompany && this.currentCompany.tax_type) {
                          return (this.currentCompany.tax_type.includes(tab.code) && !this.currentCompany.tax_type.includes('igic2019')) || this.has_meta_igic;
                      } else if (tab.code == 'igi'  && this.currentCompany && this.currentCompany.tax_type) {
                          return this.currentCompany.tax_type == tab.code || this.has_meta_igi;
                      }
                      return [];
                  });
              }
  
              /*
              const locationsTabsMap = {
                  'peninsula': 'iva',
                  'canarias': 'igic',
                  'canarias_2019': 'igic2019',
                  'andorra': 'igi',
              };
              let tab_selected = visibleTabs.filter(tab => {
                  if(locationsTabsMap[this.currentDocument.fiscal_location] === tab.code) {
                      return true;
                  }
              });
              if (tab_selected !== undefined && tab_selected.length > 0) {
                  alert(tab_selected[0].code)
                  this.clickedTab = tab_selected[0];
              }
              */
  
              return visibleTabs;
          },
          on_fiscal_location_changed() {
              this.fiscal_location_error = ''; // Reset error message
          
              if (this.currentDocument.fiscal_location) {
                  const location_meta_map = {
                      peninsula: this.has_meta_iva,
                      canarias_2019: this.has_meta_igic2019,
                      canarias: this.has_meta_igic,
                      andorra: this.has_meta_igi,
                  };
          
                  // Check if the selected fiscal location is valid.
                  const is_valid_location = Object.entries(location_meta_map).some(
                      ([location, has_meta]) => has_meta && this.currentDocument.fiscal_location === location
                  );
          
                  if (!is_valid_location) {
                      // Build the error message.
                      this.fiscal_location_error = `Localización Fiscal ${this.currentDocument.fiscal_location.toUpperCase()} Seleccionada. El documento tiene información de: `;
          
                      const impost_meta_list = [
                          { has_meta: this.has_meta_iva, name: 'IVA' },
                          { has_meta: this.has_meta_igic2019, name: 'IGIC 2019' },
                          { has_meta: this.has_meta_igic, name: 'IGIC' },
                          { has_meta: this.has_meta_igi, name: 'IGI' }
                      ];
          
                      // Append applicable error details.
                      this.fiscal_location_error += impost_meta_list
                          .filter(meta => meta.has_meta)
                          .map(meta => meta.name)
                          .join(', ');
                  }
              }

              this.setDirty();
          },
          showDateErrorHover() {
              try{
                  let date_fields = this.currentDocument.metadata['invoice_date'].split('/');
                  if (date_fields.length == 3) {
                      let date = date_fields[2] + '-' + date_fields[1] + '-' + date_fields[0];
                      return !dateIsInPaths(date, this.currentDocument['paths']);
                  }
                  return false;
              }catch(e){
                  return false
              }
          },
          show_third_concept() {
              return !(this.currentDocument.state=='done' && !this.currentDocument.metadata['third_concept']) && this.feature_expens_account_metadata && this.currentCompany && this.currentCompany.companydb_type.params && this.currentCompany.companydb_type.params['show'] && this.currentCompany.companydb_type.params['show'].includes('expens_account_metadata') && (this.document_supplierdb_info || this.document_customerdb_info);
          },
          valid_expens_accounts() {
              let is_valid = false;
              if(this.currentDocument.companydb_info && this.currentDocument.companydb_info.companydb_type && this.currentDocument.companydb_info.companydb_type.params && this.currentDocument.companydb_info.companydb_type.params.check_expens_income_accounts){
                  if (this.document_supplierdb_info && this.document_supplierdb_info['expens_accounts']) {
                      is_valid = true;
                      if (!this.document_supplierdb_info['expens_accounts'].length) {
                          is_valid = false;
                      } else {
                          for (let i in this.document_supplierdb_info['expens_accounts']) {
                              if (!this.document_supplierdb_info['expens_accounts'][i].length) {
                                  is_valid = false;
                              }
                          }
                      }
                  }
              }
              else{
                  is_valid = true;
              }
              return is_valid;
          },
          valid_expens_account_bien_inversion() {
              let is_valid = false;
              let companydb_type_params = this.currentDocument.companydb_info && this.currentDocument.companydb_info.companydb_type && this.currentDocument.companydb_info.companydb_type.params;
              if(this.currentDocument.bien_inversion && companydb_type_params && companydb_type_params.check_expens_income_accounts && !this.show_third_concept && !('hide' in companydb_type_params && companydb_type_params['hide'].includes('expens_account_bien_inversion'))){
                  if(this.document_supplierdb_info && this.document_supplierdb_info['expens_account_bien_inversion'] && this.document_supplierdb_info['expens_account_bien_inversion'].length) {
                      is_valid = true;
                  }
              }
              else {
                  is_valid = true;
              }
              return is_valid;
          },
          valid_income_accounts() {
              let is_valid = false;
              if(this.currentDocument.companydb_info && this.currentDocument.companydb_info.companydb_type && this.currentDocument.companydb_info.companydb_type.params && this.currentDocument.companydb_info.companydb_type.params.check_expens_income_accounts){
                  if (this.document_customerdb_info && this.document_customerdb_info['income_accounts']) {
                      is_valid = true;
                      if (!this.document_customerdb_info['income_accounts'].length) {
                          is_valid = false;
                      } else {
                          for (let i in this.document_customerdb_info['income_accounts']) {
                              if (!this.document_customerdb_info['income_accounts'][i].length) {
                                  is_valid = false;
                              }
                          }
                      }
                  }
              }
              else{
                  is_valid = true
              }
              return is_valid;
          },
          // currentPath() {
          //     let path = false;
          //     if (this.currentDocument.metadata['invoice_date'] && this.currentDocument['paths'].length) {
          //         let date_fields = this.currentDocument.metadata['invoice_date'].split('/');
          //         if (date_fields.length == 3) {
          //             let year = date_fields[2];
          //             for (let i in this.currentDocument['paths']) {
          //                 let path_year = this.currentDocument['paths'][i]['min_date'].split('-')[0];
          //                 if (year == path_year) {
          //                     path = this.currentDocument['paths'][i];
          //                 }
          //             }
          //         }
          //     }
          //     return path;
          // },
          show_retention_type_name() {
              let show = false;
              if (!(this.document_retention_type_name == 'third_value' && ['done','done_manually', 'done_with_warning'].includes(this.currentDocument.state))) {
                  let show_cdb_type = this.currentCompany && this.currentCompany.companydb_type.params && this.currentCompany.companydb_type.params['show'] && this.currentCompany.companydb_type.params['show'].includes('customer_retention_type');
                  if (this.document_kind == 'in_invoice' || (this.feature_customer_retention_type && show_cdb_type)) {
                      show = true;
                  }
              }
              return show;
          },
          filtered_retention_types() {
            return this.get_retention_types.filter(element => {
              const isAgricultureOrLivestock = element.value === 'retention_agriculture_account' || element.value === 'retention_livestock_account';
              const isCapital = element.value === 'retention_capital_account';
              const isTransport = element.value === 'retention_transport_account';
              const isProfessionalStartActivity = element.value === 'retention_professional_start_act_account';                

              if ((!this.currentCompany.iva_agrario_pesca || !this.feature_retention_accounts_agrario) && isAgricultureOrLivestock) {
                return false;
              }
              if (!this.got_feature('feature_capital_retention') && isCapital) {
                return false;
              }
              if (!this.got_feature('feature_retention_professional_start_activity') && isProfessionalStartActivity) {
                  return false;
              }
              if (isTransport && (this.document_kind == 'out_invoice' || !this.got_feature('feature_retention_accounts_transport'))) {
                  return false;
              }
              return true;
            });
          },
          taxTypesDoNotMatch() {
              const valueIsFalsyOrZeroString = v => {
                  if (!v) return true

                  if (typeof v === 'string') {
                      const parsedValue = parseFloat(v)
                      if (!parsedValue && !_.isNaN(parsedValue)) return true
                  }

                  return false
              }

              const taxRegex = new RegExp('[^_\W]+')
              const vatBases = this.vat.map(e => `base_${e.vat}`)
              const igicBases = this.igic.map(e => `base_${e.vat}`)
              const metadataNoFalsies = _.pickBy(this.currentDocument.metadata, v => !valueIsFalsyOrZeroString(v)) 
              const taxType = this.selectedParamOption ? this.selectedParamOption.match(taxRegex)[0] : ''

              if (this.selectedParam !== 'intracomunitario') return false

              if (taxType === 'vat') {
                  return _.intersection(vatBases, Object.keys(metadataNoFalsies)).length === 0
              } else if (taxType === 'igic') {
                  return _.intersection(igicBases, Object.keys(metadataNoFalsies)).length === 0
              }
              return true
          },
          apply_modelo_label() {
              let label = 'Aplica 34';
              if (this.selectedParam == 'intracomunitario') {
                  label = label + '9';
              } else {
                  label = label + '7';
              }
              return label;
          },
          readOnlyThirdConcept(){
             return this.currentCompany.companydb_type.value == 'aplifisa_fiscal' && this.currentCompany.companydb_type.params && this.currentCompany.companydb_type.params.hasOwnProperty('hide') && this.currentCompany.companydb_type.params.hide.includes('expens_account_bien_inversion') && this.currentDocument.bien_inversion && this.valid_expens_account_bien_inversion
          },
          automaticPaymentAccountLabel() {
              let value = null

              if (this.automaticPaymentAccount) {
                  value = this.labelArray.filter(e => e.value === this.automaticPaymentAccount)[0]
                  value = value.text
              }

              return value
          },
          automaticChargeAccountLabel() {
              let value = null

              if (this.automaticChargeAccount) {
                  value = this.labelArray.filter(e => e.value === this.automaticChargeAccount)[0]
                  value = value.text
              }

              return value
          },
          noDeducibleCheckError() {
              return this.currentDocument && ['error_validating_data'].includes(this.currentDocument.state) && this.currentDocument.errorJson.includes('iva_igic_no_deducible');
          },
          isComercianteMinoristaCheckError() {
            return this.currentDocument && ['error_validating_data'].includes(this.currentDocument.state) && this.currentDocument.errorJson.includes('is_comerciante_minorista');
          },
          feature_supplier_comerciante_minorista() {
              let has_perm = false;
              if (this.got_feature('feature_supplier_comerciante_minorista') && this.currentDocument.companydb_info.tax_type == 'igic') {
                  has_perm = true;
              }
              return has_perm;
          },
          is_rectificativa() {
              let is_rect = false;
              if (this.currentDocument.metadata && this.currentDocument.metadata['total_amount']) {
                  if (this.currentDocument.metadata['total_amount'] < 0.0) {
                      is_rect = true;
                  }
              }
              return is_rect;
          },
          url_get_invoices_to_rectify() {
              let url = 'docs_for_rectify/?company_id=' + this.currentCompany.id + '&kind=' + this.document_kind;
              if (this.document_kind == 'in_invoice' && this.supplierdb_info) {
                  url += '&supplier_id=' + this.supplierdb_info.id;
              } else if (this.document_kind == 'out_invoice' && this.customerdb_info) {
                  url += '&customer_id=' + this.customerdb_info.id;
              }
              return url;
          },
          inv_number_to_rectify_error() {
              let error = false;
              if (
                  this.currentDocument.state == 'error_missing_fields' &&
                  this.currentDocument.errorJson['missing_fields'] &&
                  this.currentDocument.errorJson['missing_fields'].length > 0 && 
                  this.currentDocument.errorJson['missing_fields'].includes('inv_number_to_rectify')
              ) {
                  error = true;
              }
              return error;
          }, 
          inv_date_to_rectify_error() {
              let error = false;
              if (
                  (
                      this.currentDocument.state == 'error_missing_fields' &&
                      this.currentDocument.errorJson['missing_fields'] &&
                      this.currentDocument.errorJson['missing_fields'].length > 0 && 
                      this.currentDocument.errorJson['missing_fields'].includes('inv_date_to_rectify')
                  ) || (
                      this.currentDocument.state == 'error_validating_data' &&
                      this.currentDocument.errorJson &&
                      this.currentDocument.errorJson.length > 0 &&
                      this.currentDocument.errorJson.includes('inv_date_to_rectify')
                  )
              ) {
                  error = true;
              }
              return error;
          }
      },
      watch: {
          selectedParam() {
              setTimeout(() => {
                  this.lastSelectedParam = this.selectedParam;
              })
              if(['no_sujeta','dry_0_percent','inversion_sujeto_pasivo_igic'].includes(this.selectedParam)){
                  let third_params = {}
                  third_params[this.selectedParam] = true
                  this.setType0(third_params)
              }
              else if(['no_sujeta','dry_0_percent','inversion_sujeto_pasivo_igic'].includes(this.lastSelectedParam)){
                  let third_params = {}
                  this.setType0(third_params)
              }
              this.setIntraDataFromCustom({param: this.selectedParam, value: this.selectedParamOption, value2: this.selectedParamOption2})
          },
          selectedParamOption() {
              this.setIntraDataFromCustom({param: this.selectedParam, value: this.selectedParamOption, value2: this.selectedParamOption2})
          },
          selectedParamOption2() {
              this.setIntraDataFromCustom({param: this.selectedParam, value: this.selectedParamOption, value2: this.selectedParamOption2})
          },
          selectedIvaCheck() {
              setTimeout(() => {
                  this.lastSelectedIvaCheck = this.selectedIvaCheck;
              })
          },
          document_supplierdb_info(new_sup, old_sup) {
              if (((new_sup && old_sup) && (new_sup.id!=old_sup.id)) || (new_sup && !old_sup)) {
                  this.updateAutomaticMoveAccounts()
                  this.setType0(this.document_supplierdb_info)
                  this.setIntraDataFromThirdParty(this.document_supplierdb_info);
                  if(this.feature_criterio_de_caja) {
                      this.setCriteriodeCaja(this.document_supplierdb_info);
                  }
                  if (this.feature_supplier_comerciante_minorista) { // Es un computed que usa got_feature
                      this.setIsComercianteMinorista(this.document_supplierdb_info);
                  }
                  this.documentToParam();
                  this.getRetentionTypeFromThird();
              }
              //Si ha cambiado la contrapartida del proveedor
              else if (new_sup && old_sup && new_sup.id==old_sup.id && new_sup.expens_accounts && new_sup.expens_accounts.length > 0 && old_sup.expens_accounts && old_sup.expens_accounts.length > 0 && new_sup.expens_accounts[0] != old_sup.expens_accounts[0]) {
                this.setSupplierAccount();
              }
          },
          document_customerdb_info(new_cus, old_cus) {
              if (((new_cus && old_cus) && (new_cus.id!=old_cus.id)) || (new_cus && !old_cus)) {
                  this.updateAutomaticMoveAccounts()
                  this.setType0(this.document_customerdb_info)
                  this.setIntraDataFromThirdParty(this.document_customerdb_info);
                  this.documentToParam();
                  this.getRetentionTypeFromThird();
              }
              //Si ha cambiado la contrapartida del cliente
              else if (new_cus && old_cus && new_cus.id==old_cus.id && new_cus.income_accounts && new_cus.income_accounts.length > 0 && old_cus.income_accounts && old_cus.income_accounts.length > 0 && new_cus.income_accounts[0] != old_cus.income_accounts[0]) {
                this.setCustomerAccount();
              }
          },
      },
      methods:{
          ...mapActions("cru", ['getAccounts']),
          ...mapActions("cookies", ['initialThirdPartyValuesModal', 'setThirdPartyPosition']),
          ...mapActions("documents", ['updateAutomaticMoveAccounts']),
          // ==========
          // ==========
          setDateErrors(){
            this.date_errors = invoiceDateErrors(
              this.currentDocument.metadata['invoice_date'],
              this.currentDocument.default_accounting_date,
              this.currentDocument.accounting_date_config,
              this.currentDocument.default_registro_date,
              this.currentDocument.registro_date_config,
              new VueFeatureRepository(this.got_feature),
            )
            this.inAccounting_errors = inAccountingPeriodErrors(
              this.currentDocument.metadata['invoice_date'],
              this.currentDocument.default_accounting_date,
              this.currentDocument.accounting_date_config,
              this.currentDocument.default_registro_date,
              this.currentDocument.registro_date_config,
              this.currentDocument['paths']
            )
            this.error5years = diff5Years(this.currentDocument.metadata['invoice_date'], this.currentDocument.default_accounting_date, this.currentDocument.accounting_date_config)
          },
          dateErrors_and_setDirty() {
            this.setDateErrors()
            this.setDirty()
            this.$emit('invoice-date-changed')
          },
          // ==========
          // ==========
          currentPath() {
              let path = false;
              let year = false;
              let date_fields = false;
              if(this.currentDocument.accounting_date_config=='invoice_date'){
                  date_fields = this.currentDocument.metadata['invoice_date'].split('/');
              }
              if(this.currentDocument.accounting_date_config=='today'){
                  let today = new Date();
                  date_fields = [today.getDate(), (today.getMonth() + 1), today.getFullYear()];
              }
              if(this.currentDocument.accounting_date_config=='configurated'){
                  date_fields = this.currentDocument.default_accounting_date.split('/');
              }
              if (date_fields && date_fields.length == 3) {
                  year = date_fields[2];
              }
              if (year && this.currentDocument['paths'].length) {
                  for (let i in this.currentDocument['paths']) {
                      let path_year = this.currentDocument['paths'][i]['min_date'].split('-')[0];
                      if (year == path_year) {
                          path = this.currentDocument['paths'][i];
                      }
                  }
              }
              return path;
          },
          get_label(vat){
              if(vat.vat == 'vat_0'){
                  if(!this.got_feature('feature_exenta_no_sujeta')){
                      return '0%'
                  }
                  else if(this.currentDocument.intracomunitario){
                      return '0% Intra'
                  }
                  else if(this.currentDocument.extracomunitario){
                      return '0% Extr.'
                  }
                  else if(this.currentDocument.inversion_sujeto_pasivo_iva){
                      return '0% ISP'
                  }   
              }
              else if(vat.vat == 'igic_0'){
                  if(!this.got_feature('feature_exenta_no_sujeta')){
                      return '0%'
                  }
                  else if(this.currentDocument.intracomunitario){
                      return '0% Intra'
                  }
                  else if(this.currentDocument.extracomunitario){
                      return '0% Extr.'
                  }
                  else if(this.currentDocument.inversion_sujeto_pasivo_igic){
                      return '0% ISP'
                  }   
                  else if (this.currentDocument.is_comerciante_minorista) {
                      return '0% CM'
                  }
              }
              return vat.label
          },
          show_vat(vat){
              if(['vat_10_5','vat_12'].includes(vat) && !this.currentCompany.iva_agrario_pesca){
                  return false
              }
              if(['vat_re_1_75'].includes(vat) && !this.currentCompany.iva_tabaco){
                  return false
              }
              if(['vat_5'].includes(vat) && !this.feature_vat_5){
                  return false
              }
              if(['vat_ns_0','vat_ne_0','igic_ns_0','igic_ne_0'].includes(vat) && !this.got_feature('feature_exenta_no_sujeta')){
                  return false
              }
              if(['vat_re_625'].includes(vat) && !this.got_feature('feature_vat_re_625')){
                  return false
              }
              if (['igic_5'].includes(vat) && !this.got_feature('feature_igic_5')) {
                  return false
              }
              return true
          },
          toggleParam() {
              this.setDirty()
              if (this.selectedParam == this.lastSelectedParam) {
                  this.selectedParam = undefined
              }
          },
          toggleIsRectificativa() {
              for (let i in this.tabs) {
                  if (this.tabs[i].code != "params") {
                      for (let z in this.tabs[i].vats) {
                          if ((("metadata_base_" + this.tabs[i].vats[z].vat) in this) && this['metadata_base_' + this.tabs[i].vats[z].vat]) {
                          //if (("base_" + this.tabs[i].vats[z].vat) in this.currentDocument.metadata) {
                              //this.currentDocument.metadata["base_" + this.tabs[i].vats[z].vat] = this.currentDocument.metadata["base_" + this.tabs[i].vats[z].vat] * (-1);
                              this['metadata_base_' + this.tabs[i].vats[z].vat] = this['metadata_base_' + this.tabs[i].vats[z].vat] * (-1);
                          }
                          if ((("metadata_" + this.tabs[i].vats[z].vat) in this) && this['metadata_' + this.tabs[i].vats[z].vat]) {
                              this['metadata_'+ this.tabs[i].vats[z].vat] = this['metadata_' + this.tabs[i].vats[z].vat] * (-1);
                          }
                      }
                  }                    
              }
              //this.currentDocument.metadata["total_amount"] = this.currentDocument.metadata["total_amount"] * (-1);
              if (('metadata_total_amount' in this) && this['metadata_total_amount']) {
                  this['metadata_total_amount'] =  this['metadata_total_amount'] * (-1);
              }                
          },
          resetParamOption() {
              this.selectedParamOption = undefined;
              this.selectedParamOption2 = undefined;
          },
          toggleParamIva() {
              if (this.selectedIvaCheck == this.lastSelectedIvaCheck) {
                  this.selectedIvaCheck = undefined;
              }
              this.document_comerciante_minorista = false;
              this.document_gasto_iva_percent = 50;
          },
          ...mapActions({
              setIntraDataFromThirdParty: "documents/setIntraDataFromThirdParty",
              setCriteriodeCaja: "documents/setCriteriodeCaja",
              setIsComercianteMinorista: "documents/setIsComercianteMinorista",
              setIntraDataFromCustom: "documents/setIntraDataFromCustom",
              setDirty: "documents/setDirty",
              documentToParam: "documents/documentToParam",
              setType0: "documents/setType0"
          }),
          show_modal(){
              this.initialThirdPartyValuesModal();
              if(this.document_kind=='in_invoice'){
                  // this.showModalSupplier = true
                  this.$modal.show('modal-supplier');
              }
              else{
                  // this.showModalCustomer = true
                  this.$modal.show('modal-customer');
              }
          },
          setSupplierAccount(){
              if (this.currentDocument.supplierdb_info && this.currentDocument.companydb_info && this.currentDocument.companydb_info.companydb_type && this.currentDocument.companydb_info.companydb_type.type == 'invoice' && this.currentDocument.companydb_info.companydb_type.params && this.currentDocument.companydb_info.companydb_type.params.desglose_de_cuentas) {
                  for(let i in this.tabs){
                      let vats = this.tabs[i].vats
                      for(let j in vats){
                          let vat = vats[j].vat
                          if(this['metadata_base_'+vat] || this['metadata_'+vat] || this['metadata_account_'+vat]){
                              this['metadata_account_'+vat] = this.currentDocument.supplierdb_info.expens_accounts[0]
                          }
                      }
                  }
              }
          },
          setCustomerAccount(){
              if (this.currentDocument.companydb_info && this.currentDocument.companydb_info.companydb_type && this.currentDocument.companydb_info.companydb_type.type == 'invoice' && this.currentDocument.companydb_info.companydb_type.params && this.currentDocument.companydb_info.companydb_type.params.desglose_de_cuentas) {
                  for(let i in this.tabs){
                      let vats = this.tabs[i].vats
                      for(let j in vats){
                          let vat = vats[j].vat
                          if(this['metadata_base_'+vat] || this['metadata_'+vat] || this['metadata_account_'+vat]){
                              this['metadata_account_'+vat] = this.currentDocument.customerdb_info.income_accounts[0]
                          }
                      }
                  }
              }
          },
          on_supplierdb_changed() {
              this.setType0(this.document_supplierdb_info)
              this.setIntraDataFromThirdParty(this.document_supplierdb_info);
              if(this.feature_criterio_de_caja) {
                  this.setCriteriodeCaja(this.document_supplierdb_info);
              }
              if (this.feature_supplier_comerciante_minorista) { // Es un computed que usa got_feature
                  this.setIsComercianteMinorista(this.document_supplierdb_info)
              }

                this.documentToParam()
                this.setDirty();
                this.setSupplierAccount()
                this.getRetentionTypeFromThird();
            },
            on_customerdb_changed() {
                this.setType0(this.document_customerdb_info)
                this.setIntraDataFromThirdParty(this.document_customerdb_info);
                this.documentToParam();
                this.setDirty();
                this.setCustomerAccount();
                this.getRetentionTypeFromThird();
            },
            filterBy(item, queryText, itemText) {
                const text = item.selector_text.toLowerCase();
                const searchText = queryText.toLowerCase();
                return text.indexOf(searchText) > -1;
            },
            get_tipo_cols(){
                if(!this.showCustomRet)
                    return 4
                else{
                    return 3
                }
            },
            get_cuota_cols(){
                if(!this.showCustomRet)
                    return 4
                else{
                    return 3
                }
            },
            canChange() {
                const STATES = [
                    'pending_connect',
                    'done',
                    'done_manually',
                    'accounting_aplifisa_fiscal',
                    'accounting_invoice',
                    'done_with_warning',
                    'pending_sync',
                    'pending_upload',
                    'accounting',
                ];
                return Boolean(!(this.currentDocument && (this.isWaitingFlow || STATES.includes(this.currentDocument.state))) || this.fixMotxo);
            },
            getRetentionTypeFromThird() {
                if (this.document_kind == 'in_invoice') {
                    if (this.document_supplierdb_info && this.document_supplierdb_info['retention_type']) {
                        /*
                        if (this.document_supplierdb_info['retention_type'] == 'retention_professional_start_act_account') {
                            this.document_retention_type_name = 'retention_professional_account'
                        } else {
                            this.document_retention_type_name = this.document_supplierdb_info['retention_type'];
                        } */
                        this.document_retention_type_name = this.document_supplierdb_info['retention_type'];
                    }
                } else if (this.document_kind == 'out_invoice' && this.feature_customer_retention_type) {
                    if (this.document_customerdb_info && this.document_customerdb_info['retention_type']) {
                        /*
                        if (this.document_customerdb_info['retention_type'] == 'retention_professional_start_act_account') {
                            this.document_retention_type_name = 'retention_professional_account'
                        } else {
                            this.document_retention_type_name = this.document_customerdb_info['retention_type'];
                        }*/
                        this.document_retention_type_name = this.document_customerdb_info['retention_type']; 
                    }
                }
            },
            getValues(params) {
                this.getAccounts(params).then(() => {});
            },
            resetItems(params) {
                this.accounts = params;
            },
            checkBienInversion() {
                this.setDirty()
                // REBU y Bienes de Inversión son mutuamente excluyentes
                if (this.document_bien_inversion && this.document_rebu) {
                    this.document_rebu = false;
                    this.document_rebu_precio_compra = null;
                }
                if (this.show_third_concept && this.currentDocument.companydb_info.companydb_type.value === 'aplifisa_fiscal'){
                    if (this.document_bien_inversion){
                        this.metadata_third_concept="200";
                    }
                    else if(!this.document_bien_inversion && this.document_supplierdb_info && this.document_supplierdb_info['expens_accounts']){
                        this.metadata_third_concept=this.document_supplierdb_info['expens_accounts'][0]
                    }
                }
            },
            checkRebu() {
                this.setDirty()
                // REBU y Bienes de Inversión son mutuamente excluyentes
                if (this.document_rebu && this.document_bien_inversion) {
                    this.document_bien_inversion = false;
                }
                if (!this.document_rebu) {
                    this.document_rebu_precio_compra = null;
                }
            },
            changeInvNumberToRectify() {
                if (typeof this.invoice_to_rectify == 'object') {
                    this.document_inv_number_to_rectify = this.invoice_to_rectify['inv_number'];
                    if (this.got_feature('feature_invoice_date_to_rectify')) {
                        this.document_inv_date_to_rectify = this.invoice_to_rectify['metadata']['invoice_date'];
                    }
                } else {
                    this.document_inv_number_to_rectify = this.invoice_to_rectify;
                }
            },
            showRectifyFields() {
                return this.rectification_invoice && this.got_feature('feature_invoice_number_to_rectify') && (this.currentDocument.kind=='out_invoice' || (this.currentDocument.kind=='in_invoice' && !this.got_feature('feature_hide_rectify_fields_in_invoice')));
            },
            showDocNumberStr() {
                return this.got_feature('feature_document_number_str') && this.currentCompany.configuration && 'document_doc_number' in this.currentCompany.configuration && this.currentCompany.configuration['document_doc_number'];
            },
        },
        data(){
            return {
                show_account_detail:false,
                dialog_vat:'',
                PROVIDER_SOMETHING_OPTIONS,
                PROVIDER_SOMETHING_OPTIONS2,
                clickedTab: undefined,
                // selectedParam: undefined,
                // lastSelectedParam: undefined,
                // selectedParamOption: undefined,
                supps: [],
                conf_ret_button:false,
                labelArray: [{'text': 'N/A', 'value': 'na'}, {'text': 'Si', 'value': 'y'}, {'text': 'No', 'value': 'n'}],
                declined_matching:false,
                invoice_to_rectify: '',
                rectification_invoice: undefined,
                fiscal_location_error: '',
                fiscal_locations:[],
                // ==========
                // ==========
                date_tooltips: {
                  no_acc_period: "No existe en la empresa ningún ejercicio para esta fecha",
                  acc_date_before_invoice: "La Fecha contable debe ser igual o posterior a la Fecha factura",
                  // reg_date_before_accounting: "La Fecha de registro debe ser igual o posterior a la Fecha contable y a la Fecha factura",
                  reg_date_before_invoice: "La Fecha registro debe ser igual o posterior a la Fecha factura",
                  acc_inv_5y: "El periodo de la Fecha contable a la de factura debe ser inferior a 5 años",
                  no_future_date: "Las fechas factura y contable no pueden ser posteriores a la fecha actual"
                },
                future_errors: {invoice : false, accounting : false, registro : false},
                date_errors: {invoice : false, accounting : false, registro : false},
                inAccounting_errors: {invoice : false, accounting : false, registro : false},
                error5years: null,
                color: { ok : '#ffffff', error : '#ff9898'},
                // ==========
                // ==========
            }
        },
        mounted() {
          new GetFiscalLocationInfoQuery(query_dispatcher, this).run();

          if (this.selectedParam) {
              this.lastSelectedParam = this.selectedParam;
          }
          if (this.selectedIvaCheck) {
              this.lastSelectedIvaCheck = this.selectedIvaCheck;
          }
          if (!['done','done_manually', 'done_with_warning'].includes(this.currentDocument.state) && this.document_retention_type_name == 'third_value') {
              this.getRetentionTypeFromThird();
          }
          if (this.document_inv_number_to_rectify) {
              this.invoice_to_rectify = this.document_inv_number_to_rectify;
          }

          // ==========
          // ==========
          this.setDateErrors() // init date_errors and inAccounting_errors
          // ==========
          // ==========
      },
      
  }
</script>

<style scoped>
  .table-head-invoice {
      border-left-style:solid;
      border-right-style:solid;
      border-bottom-style:solid;
      border-color:var(--v-primary-base);
      border-width: thin;
  }
  .table-row-invoice {
      border-left-style:solid;
      border-right-style:solid;
      border-bottom-style:solid;
      border-color:var(--v-primary-base);
      border-width: thin;
  }
  div.table-iva > div > div {
      border-top-style:solid;
      border-color:var(--v-primary-base);
      border-width: thin;
  }
  .table-row-invoice >>> div > .row > .col > div > .v-text-field {
      margin-top: 0px;
  }
  .table-row-invoice >>> div > .v-text-field {
      margin-top: 0px;
  }
  .table-row-invoice >>> div > .row > .col > div > .v-text-field > .v-input__control > .v-input__slot {
      height: 36px;
  }
  .table-row-invoice >>> div > .v-text-field > .v-input__control > .v-input__slot {
      height: 36px;
  }
  .error-background {
      background-color: #ea817a; /* Light red background for error */
  }

</style>
